export const localesTranslations: {[locale: string]: string} = {
    fr: "Français",
    en: "English",
    bg: "Български",
    cs: "Čeština",
    da: "Dansk",
    de: "Deutsch",
    el: "Ελληνικά",
    es: "Español",
    hu: "Magyar",
    it: "Italiano",
    lt: "Lietuvių",
    lv: "Latviešu",
    nl: "Nederlands",
    pl: "Polski",
    pt: "Português",
    ro: "Română",
    ru: "Русский",
    ar: "العربية",
};
